import { type BootstrapData, BOOTSTRAP_SCHEMA_VERSION } from '@/types/bootstrap';

/**
 * Parse the server-injected #app-bootstrap data island (W4 D2/D3). Returns null
 * when absent, malformed, or on a schema-version mismatch (rolling deploy) — the
 * caller then falls back to the normal API fetch. Injection-preferred,
 * API-authoritative.
 */
export function readBootstrap(): BootstrapData | null {
  const el = document.getElementById('app-bootstrap');
  if (!el?.textContent) return null;
  try {
    const data = JSON.parse(el.textContent) as BootstrapData;
    if (data.schemaVersion !== BOOTSTRAP_SCHEMA_VERSION) return null;
    return data;
  } catch {
    return null;
  }
}
